var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scroll" }, [
    _c("article", { staticClass: "contents" }, [
      _c("div", { staticClass: "form" }, [
        _c(
          "div",
          { staticClass: "form-row" },
          [
            _c("input-text", {
              attrs: {
                id: "lcalBnkBrnEngName",
                value: _vm.lcalBnkBrnEngName,
                labelI18n: "MPRS-02-02-02-05",
                required: ""
              },
              on: {
                "update:value": function($event) {
                  _vm.lcalBnkBrnEngName = $event
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "form-row" },
          [
            _c("input-text", {
              attrs: {
                id: "inquiryAcno",
                value: _vm.inquiryAcno,
                labelI18n: "MPRS-02-02-02-05",
                required: "",
                alphaNum: "",
                maxByte: 20
              },
              on: {
                "update:value": function($event) {
                  _vm.inquiryAcno = $event
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "form-row" },
          [
            _c("input-text", {
              attrs: {
                id: "inquiryDpstrName",
                value: _vm.inquiryDpstrName,
                labelI18n: "MPRS-02-02-02-05",
                required: "",
                localeCase3: "",
                maxByte: 70
              },
              on: {
                "update:value": function($event) {
                  _vm.inquiryDpstrName = $event
                }
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }